export const SEND_GA_ANALYTICS = (pathname) => {
    if (window.ga) {
        window.ga('send', {
            hitType: 'pageview',
            page: pathname
        });
    }
}